module.exports = __webpack_public_path__ + "85f4e95c9dfdb8932c4fb29193cf372e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/feet/planet-saturn.png
// module id = 2412
// module chunks = 0